import React from 'react';
import Home from '../defaults/Home';

export default (props) => {
  return (
    <Home />
  );
}
